import React from 'react';
import { Link } from 'react-router-dom';
import { widths, fonts, heights, breakpoints } from './../../styles/theme.json';

const HeroSliderCaption = (props) => {
  return (
    <div className={'caption-out'}>
      {
        (props.caption.link.slug)
        ? <Link to={
            (props.caption.link.postType != 'page')
            ? '/' + props.caption.link.postType + '/' + props.caption.link.slug
            : '/' + props.caption.link.slug
          } >
            <div className={'big-link'}></div>
          </Link>
        : null
      }       
      <div className={'caption-wrapper'}> 
        <div className={'caption'}>
          <div className={'caption-content'}>
            <h4>{props.caption.header}</h4>
            <h5>{props.caption.title}</h5>
            {
              (props.caption.additional_info) &&
              <h5>{props.caption.additional_info}</h5>
            }
            {
              (props.caption.link.slug && props.caption.link_type == 'Internal') &&
                <Link to={
                  (props.caption.link.postType != 'page')
                  ? '/' + props.caption.link.postType + '/' + props.caption.link.slug
                  : '/' + props.caption.link.slug
                } className="slider-caption-link">
                  {(props.caption.link.postType == 'films') ? <span>WATCH</span> : <span>VIEW</span>}
                </Link>
            }
            {
              (props.caption.link_type == 'External') &&
                <a target="_blank" href={props.caption.external_link} className="slider-caption-link"><span>{props.caption.external_link_text}</span></a>              
            }
          </div>
        </div>
      </div>  
      <style jsx>{`
        .caption-out {
        }
    
        .big-link {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 100vh;
          display: block;
          z-index: 100;
        }
        @media only screen and (max-width: 640px) {
          .big-link {
            display: block;
          }
        }            
        .caption-wrapper {
          position: absolute;
          bottom: 8rem;
          right: 0;
          display: flex;
          width: 100vw;
          justify-content: center;
          padding-left: ${widths.double_pad};
          padding-right: ${widths.double_pad};
        }
        .caption {
          color: #FFF;
          z-index: 100;
          text-transform: uppercase;
          width: 100%;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          text-align: center;
        }
        .caption-content {
          width: 100%;
        }
        h4 {
          font-family: ${fonts.mallory};
          margin-bottom: .25rem;
          font-size: 1.5rem;
          font-weight: 700;
          letter-spacing: ${fonts.caption_spacing};
          line-height: 1.25;
        }
        h5 {
          font-family: ${fonts.mallory};
          font-size: 1.5rem;
          font-weight: 300;
          letter-spacing: ${fonts.caption_spacing};
          line-height: 1.25;
        }
        @media only screen and (min-width: 640px) {
          .caption {
            text-align: left;
          }
          .caption-wrapper {
            height: ${heights.slider_caption};
            bottom: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default HeroSliderCaption;



// WEBPACK FOOTER //
// ./src/components/hero/HeroSliderCaption.js